"use client"

import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import ProjectCard from "./ProjectCard"
import Pagination from "../pagination"

export default function ProjectList({ toggleFiltersModal, openCompleteProjectModal, userId, filters, setFilters }) {
  const [projects, setProjects] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [searchTerm, setSearchTerm] = useState("")
  const itemsPerPage = 6

  useEffect(() => {
    fetchProjects()
  }, [currentPage, filters]) // Trigger fetch when filters or currentPage changes

  const fetchProjects = async () => {
    const { fromDate, toDate, sortBy, status } = filters; // Include status in destructuring
    const queryParams = new URLSearchParams({
      page: currentPage,
      limit: itemsPerPage,
      ...(fromDate && { fromDate }),
      ...(toDate && { toDate }),
      ...(sortBy && { sortBy }),
      ...(status && { status }), // Add status to query parameters
    });

    try {
      const response = await fetch(`http://localhost:5000/client-projects/${userId}?${queryParams.toString()}`)
      const data = await response.json()
      console.log('Fetched projects:', data); // Debug fetched data
      if (Array.isArray(data)) {
        setProjects(data)
      } else {
        console.error('Unexpected response format:', data)
        setProjects([])
      }
    } catch (error) {
      console.error('Error fetching projects:', error)
      setProjects([])
    }
  }

  const removeProject = (projectId) => {
    setProjects(projects.filter((project) => project.id !== projectId))
  }

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber)
  }


  const filteredProjects = projects.filter(
    (project) =>
      project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      project.description.toLowerCase().includes(searchTerm.toLowerCase()),
  )

  return (
    <div>
      <div style={{ background: 'var(--bg-card)', padding: '20px 24px', margin: '0 36px', border: '1px solid var(--border-glass)', borderRadius: '14px', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: 'linear-gradient(90deg, var(--accent-cyan), var(--accent-violet))' }} />
        <div className="container mx-auto">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="w-full md:w-auto">
              <form className="flex" onSubmit={e => e.preventDefault()}>
                <input
                  type="text"
                  style={{ background: 'var(--bg-elevated)', color: 'var(--text-primary)', border: '1px solid var(--border-subtle)', borderRight: 'none', padding: '12px 20px', borderRadius: '10px 0 0 10px', fontSize: '0.95rem', outline: 'none', width: '100%' }}
                  placeholder="Search projects..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <button style={{ background: 'linear-gradient(135deg, var(--accent-cyan), var(--accent-violet))', color: '#fff', padding: '12px 24px', borderRadius: '0 10px 10px 0', border: 'none', fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }} type="submit">
                  Search
                </button>
              </form>
            </div>
            <div className="flex items-center">
              <button
                style={{ background: 'var(--bg-elevated)', color: 'var(--accent-cyan)', padding: '12px 20px', borderRadius: '10px', border: '1px solid var(--border-subtle)', cursor: 'pointer', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '8px', transition: 'border-color 0.2s' }}
                type="button"
                onClick={toggleFiltersModal}
                onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--accent-cyan)'}
                onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border-subtle)'}
              >
                <i className="fas fa-filter"></i> Filters
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto my-8 px-6">
        <div className="flex justify-between items-center mb-6">
          <h1 style={{ fontSize: '1.6rem', fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'var(--font-display)' }}>Manage Your Projects</h1>
          <Link to="/ReqProject" style={{ background: 'linear-gradient(135deg, var(--accent-cyan), var(--accent-violet))', color: '#fff', padding: '12px 24px', borderRadius: '10px', fontWeight: 600, textDecoration: 'none', transition: 'opacity 0.2s' }}>
            Request New Project
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project) => (
            <ProjectCard
              key={project.client_project_id}
              project={project}
              removeProject={removeProject}
              openCompleteProjectModal={openCompleteProjectModal}
            />
          ))}
        </div>
      </div>

      <Pagination
        itemsPerPage={itemsPerPage}
        totalItems={projects.length}
        paginate={paginate}
        currentPage={currentPage}
      />
    </div>
  )
}